"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isString = isString;
exports.isDictPair = isDictPair;
exports.isRawGtv = isRawGtv;
exports.isTransactionInfoInBlockResponse = isTransactionInfoInBlockResponse;
exports.isTransactionInfoInBlockResponseArray = isTransactionInfoInBlockResponseArray;
exports.isBlockInfoResponse = isBlockInfoResponse;
exports.isBlockInfoResponseArray = isBlockInfoResponseArray;
exports.isTransaction = isTransaction;
exports.isTransactionsCount = isTransactionsCount;
exports.isTransactionConfirmationProof = isTransactionConfirmationProof;
exports.isConfirmationProof = isConfirmationProof;
exports.isTransactionInfoResponse = isTransactionInfoResponse;
exports.isTransactionInfoResponseArray = isTransactionInfoResponseArray;
exports.isTransactionInfo = isTransactionInfo;
exports.isTransactionInfoArray = isTransactionInfoArray;
exports.isRejectedTransaction = isRejectedTransaction;
exports.isRejectedTransactionArray = isRejectedTransactionArray;
exports.isRejectedTransactionResponse = isRejectedTransactionResponse;
exports.isRejectedTransactionResponseArray = isRejectedTransactionResponseArray;
const buffer_1 = require("buffer");
const zod_1 = require("zod");
const RawGtvSchema = zod_1.z.union([
    zod_1.z.boolean(),
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.bigint(),
    zod_1.z.instanceof(buffer_1.Buffer),
    zod_1.z.array(zod_1.z.unknown()),
    zod_1.z.record(zod_1.z.unknown()),
]);
const DictPairSchema = zod_1.z.record(RawGtvSchema);
const TransactionInfoInBlockResponseSchema = zod_1.z.object({
    rid: zod_1.z.string(),
    hash: zod_1.z.string(),
    data: zod_1.z.string().optional(),
});
const BlockInfoResponseSchema = zod_1.z.object({
    rid: zod_1.z.string(),
    prevBlockRID: zod_1.z.string(),
    header: zod_1.z.string(),
    height: zod_1.z.number(),
    transactions: zod_1.z.array(TransactionInfoInBlockResponseSchema),
    witness: zod_1.z.string(),
    witnesses: zod_1.z.array(zod_1.z.string()),
    timestamp: zod_1.z.number(),
});
const TransactionObjectSchema = zod_1.z.object({
    tx: zod_1.z.string(),
});
const TransactionsCountSchema = zod_1.z.object({
    transactionsCount: zod_1.z.number(),
});
const TransactionConfirmationProofSchema = zod_1.z.object({
    proof: zod_1.z.string(),
});
const ConfirmationProofSchema = zod_1.z.object({
    hash: zod_1.z.instanceof(buffer_1.Buffer),
    blockHeader: zod_1.z.instanceof(buffer_1.Buffer),
    witness: zod_1.z.instanceof(buffer_1.Buffer),
    merkleProofTree: RawGtvSchema,
    txIndex: zod_1.z.number(),
});
const TransactionInfoResponseSchema = zod_1.z.object({
    blockRID: zod_1.z.string(),
    blockHeight: zod_1.z.number(),
    blockHeader: zod_1.z.string(),
    witness: zod_1.z.string(),
    timestamp: zod_1.z.number(),
    txRID: zod_1.z.string(),
    txHash: zod_1.z.string(),
    txData: zod_1.z.string(),
});
const TransactionInfoSchema = zod_1.z.object({
    blockRid: zod_1.z.instanceof(buffer_1.Buffer),
    blockHeight: zod_1.z.number(),
    blockHeader: zod_1.z.instanceof(buffer_1.Buffer),
    witness: zod_1.z.instanceof(buffer_1.Buffer),
    timestamp: zod_1.z.number(),
    txRid: zod_1.z.instanceof(buffer_1.Buffer),
    txHash: zod_1.z.instanceof(buffer_1.Buffer),
    txData: zod_1.z.instanceof(buffer_1.Buffer),
});
const RejectedTransactionSchema = zod_1.z.object({
    txRid: zod_1.z.instanceof(buffer_1.Buffer),
    rejectReason: zod_1.z.string(),
    rejectTimestamp: zod_1.z.number(),
});
const RejectedTransactionResponseSchema = zod_1.z.object({
    txRID: zod_1.z.string(),
    rejectReason: zod_1.z.string(),
    rejectTimestamp: zod_1.z.number(),
});
function isString(value) {
    const result = zod_1.z.string().safeParse(value);
    return result.success ? value : null;
}
function isDictPair(value) {
    const result = DictPairSchema.safeParse(value);
    return result.success ? value : null;
}
function isRawGtv(value) {
    const result = RawGtvSchema.safeParse(value);
    return result.success ? value : null;
}
function isTransactionInfoInBlockResponse(value) {
    const result = TransactionInfoInBlockResponseSchema.safeParse(value);
    return result.success ? value : null;
}
function isTransactionInfoInBlockResponseArray(value) {
    const result = zod_1.z.array(TransactionInfoInBlockResponseSchema).safeParse(value);
    return result.success ? value : null;
}
function isBlockInfoResponse(value) {
    const result = BlockInfoResponseSchema.safeParse(value);
    return result.success ? value : null;
}
function isBlockInfoResponseArray(value) {
    const result = zod_1.z.array(BlockInfoResponseSchema).safeParse(value);
    return result.success ? value : null;
}
function isTransaction(value) {
    const result = TransactionObjectSchema.safeParse(value);
    return result.success ? value : null;
}
function isTransactionsCount(value) {
    const result = TransactionsCountSchema.safeParse(value);
    return result.success ? value : null;
}
function isTransactionConfirmationProof(value) {
    const result = TransactionConfirmationProofSchema.safeParse(value);
    return result.success ? value : null;
}
function isConfirmationProof(value) {
    const result = ConfirmationProofSchema.safeParse(value);
    return result.success ? value : null;
}
function isTransactionInfoResponse(value) {
    const result = TransactionInfoResponseSchema.safeParse(value);
    return result.success ? value : null;
}
function isTransactionInfoResponseArray(value) {
    const result = zod_1.z.array(TransactionInfoResponseSchema).safeParse(value);
    return result.success ? value : null;
}
function isTransactionInfo(value) {
    const result = TransactionInfoSchema.safeParse(value);
    return result.success ? value : null;
}
function isTransactionInfoArray(value) {
    const result = zod_1.z.array(TransactionInfoSchema).safeParse(value);
    return result.success ? value : null;
}
function isRejectedTransaction(value) {
    const result = RejectedTransactionSchema.safeParse(value);
    return result.success ? value : null;
}
function isRejectedTransactionArray(value) {
    const result = zod_1.z.array(RejectedTransactionSchema).safeParse(value);
    return result.success ? value : null;
}
function isRejectedTransactionResponse(value) {
    const result = RejectedTransactionResponseSchema.safeParse(value);
    return result.success ? value : null;
}
function isRejectedTransactionResponseArray(value) {
    const result = zod_1.z.array(RejectedTransactionResponseSchema).safeParse(value);
    return result.success ? value : null;
}
//# sourceMappingURL=requests.js.map